import { Inject, Injectable, InjectionToken } from '@angular/core';
import { StorageService } from './storage.service';
import { AlertType, ViasAlertService } from './vias-alert.service';
import { ViasDialogService } from './vias-dialog.service';
import { ViasUserPref, ViasUserPrefService } from './vias-user-pref.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';

export interface Persmission {
  pageId: number;
  permission: string;
}


export const MAIN_SERVER_URL = new InjectionToken<string>('MainServerURL', {
  providedIn: 'root',
  factory: () => ''
});
export const PRINT_URL = new InjectionToken<string>('PrintURL', {
  providedIn: 'root',
  factory: () => ''
});
export const SERVER_URL = new InjectionToken<string>('ServerURL', {
  providedIn: 'root',
  factory: () => ''
});
export const CONTRACTOR_SERVER_URL = new InjectionToken<string>('ContractorServerURL', {
  providedIn: 'root',
  factory: () => ''
});

@Injectable()
export class GlobalsService {
  // App Title
  public appTitle: string = 'viaShipyard';
  public selectedFirmId: number = 2;
  public appVersion: string;
  public appVersionLabel: string;
  private defaultLocale: string = 'tr_TR';
  public langId: number = 1;
  // php session id
  public sid: string;

  public selectedModuleId: number;
  public prefId: string = '';

  get userPref(): ViasUserPref {
    let t: ViasUserPref = JSON.parse(this.storage.getItem('userPref'));
    if (t.userId !== this.userId) {
      t = {userId: this.userId};
    }
    this.userPref = t;
    return t;
  }

  set userPref(t: ViasUserPref) {
    this.storage.setItem('userPref', JSON.stringify(t));
  }

  get langLocale(): string {
    const t: string = this.storage.getItem('langLocale') || this.defaultLocale;
    return t;
  }
  set langLocale(t: string) {
    this.storage.setItem('langLocale', t);
  }
  get numLocale(): string {
    const t: string = this.storage.getItem('numLocale') || this.defaultLocale;
    return t;
  }
  set numLocale(t: string) {
    this.storage.setItem('numLocale', t);
  }
  get pagePermissions(): Persmission[] {
    return JSON.parse(this.storage.getItem('permission'));
  }
  set pagePermissions(t: Persmission[]) {
    this.storage.setItem('permission', JSON.stringify(t));
  }

  // contractor id = contractor kullanici id
  get contractorUserId(): number {
    return parseInt(this.storage.getItem('contractorUserId'), 10);
  }
  set contractorUserId(t: number) {
    this.storage.setItem('contractorUserId', t);
  }
  get contractorName(): string {
    return this.storage.getItem('contractorName');
  }
  set contractorName(t: string) {
    this.storage.setItem('contractorName', t);
  }
  get contractorId(): number {
    return this.storage.getItem('contractorId');
  }
  set contractorId(t: number) {
    this.storage.setItem('contractorId', t);
  }

  // kullanici id
  get userId(): number {
    return parseInt(this.storage.getItem('userId'), 10);
  }
  set userId(t: number) {
    this.storage.setItem('userId', t);
  }
  // kullanici adi permanent !!!
  get rememberLoginName(): string {
    return this.storage.getItem('rememberLoginName', true);
  }
  set rememberLoginName(t: string) {
    this.storage.setItem('rememberLoginName', t, true);
  }
  // kullanici ad soyad
  get userNameSurname(): string {
    return this.storage.getItem('userNameSurname');
  }
  set userNameSurname(t: string) {
    this.storage.setItem('userNameSurname', t);
  }
  // userSectionId: number;
  get userSectionId(): number {
    return parseInt(this.storage.getItem('userSectionId'), 10);
  }
  set userSectionId(t: number) {
    this.storage.setItem('userSectionId', t);
  }
  //  userProjectType: number;
  get userProjectType(): number {
    return parseInt(this.storage.getItem('userProjectType'), 10);
  }
  set userProjectType(t: number) {
    this.storage.setItem('userProjectType', t);
  }
  //  userDepartmentId: number;
  get userDepartmentId(): number {
    return parseInt(this.storage.getItem('userDepartmentId'), 10);
  }
  set userDepartmentId(t: number) {
    this.storage.setItem('userDepartmentId', t);
  }
  // userDefaultModuleId: number;
  get userDefaultModuleId(): number {
    return parseInt(this.storage.getItem('userDefaultModuleId'), 10);
  }
  set userDefaultModuleId(t: number) {
    this.storage.setItem('userDefaultModuleId', t);
  }
  // userDefaultPageId: number;
  get userDefaultPageId(): number {
    return parseInt(this.storage.getItem('userDefaultPageId'), 10);
  }
  set userDefaultPageId(t: number) {
    this.storage.setItem('userDefaultPageId', t);
  }
  // userDefaultActionId: number;
  get userDefaultActionId(): number {
    return parseInt(this.storage.getItem('userDefaultActionId'), 10);
  }
  set userDefaultActionId(t: number) {
    this.storage.setItem('userDefaultActionId', t);
  }

  constructor(
    @Inject(MAIN_SERVER_URL) public mainServerURL,
    @Inject(SERVER_URL) public serverURL,
    @Inject(CONTRACTOR_SERVER_URL) public contractorServerURL,
    @Inject(PRINT_URL) public printURL,
    public storage: StorageService,
    public viasAlert: ViasAlertService,
    public viasDialog: ViasDialogService,
    public userPrefService: ViasUserPrefService,
    protected translate: TranslateService
  ) { }

  public getAppTitle(moduleName: string): string {
    return this.appTitle + (moduleName.length > 0 ? ' - ' + moduleName : '');
  }
  public isLoggedIn(): boolean {
    return this.userId > 0 ? true : false;
  }
  public isContractorLoggedIn(): boolean {
    return this.contractorUserId > 0 ? true : false;
  }
  public logout(): void {
    sessionStorage.clear();
    this.userId = 0;
  }
  public handleErrors(errors: string[]): void {
    let errorTxt = '';
    console.log('__++__', errors);
    errors.forEach(e => {
      this.translate.get('errorTexts.' + e).subscribe((translated: string) => {
        if (translated === 'errorTexts.' + e) {
          translated = e;
        }
        errorTxt += '<li>' + translated + '</li>';
      });
    });
    console.log('__++__', errorTxt);
    if (errorTxt.length > 0) {
      errorTxt = '<ul>' + errorTxt + '</ul>';
      this.viasAlert.show(errorTxt, AlertType.Error);
    }
  }
  public openDialog(openedPage: ComponentType<any>, config: {} = {}): MatDialogRef<any, any> {
    return this.viasDialog.open();
  }
  public openPrintView(url: string, hasPrintBtn: boolean = true): void {
    let newUrl = '/#/framework/print-view?hpb=';
    newUrl += hasPrintBtn ? '1' : '0';
    newUrl += '&url=';
    newUrl += encodeURIComponent(url);
    window.open(newUrl, '_blank');

    // bu da ornek olarak kalsin.
    // baska bir yontem
    //
    // const navigationExtras: NavigationExtras = {
    //   queryParams: {
    //     url
    //   }
    // };
    // this.route.navigateByUrl('/framework/print-view',  { state: { url }});
  }
  public getTranslate(str): string {
    let restrng = '';
    this.translate.get(str).subscribe((translated: string) => {
      restrng = translated;
    });
    return restrng;
  }
  public numberFormatter(data, digit?): string {
    let fractionDigits = 2;
    if (digit !== undefined) {
      fractionDigits = digit;
    }
    let val = data;
    if (isNaN(val)) {
      val = this.parseLocaleNumber(data, this.numLocale);
    }
    return Intl.NumberFormat(
      this.numLocale,
      { maximumFractionDigits: fractionDigits, minimumFractionDigits: fractionDigits }
    ).format(data);
  }
  public parseLocaleNumber(stringNumber, locale): number {
    const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');

    return parseFloat(stringNumber
      .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
      .replace(new RegExp('\\' + decimalSeparator), '.')
    );
  }
  public requestDataFormatter(data): string {
    let str = '';
    data.forEach(e => {
      str += '"' + e.id + '":' + JSON.stringify(e) + ',';
    });
    if (str.length > 0) {
      str = str.substring(0, str.length - 1);
      str = '{' + str + '}';
      str = JSON.parse(str);
    }
    return str;
  }
}
